import Vue from 'vue';
import Vuex from 'vuex';
import { createModule, ADD_TOAST_MESSAGE } from 'vuex-toast';
import {
	getOrganizations,
	getUsers,
	putUser,
	putOrganization,
	getTree,
	getLinkedFile,
	getNotLinkedFile,
	getLinkedUser,
	getDashboardAdmin,
	getDashboardProvider,
	getDashboardCustomer,
	getFolderListOperator,
	linkFolder,
	removeLinkFolder,
	deleteUser,
	deleteGroup,
	disableUser,
	enableUser,
	resetPassword,
	getFile,
	lockFile,
	unlockFile,
	confirmFile,
	getCustomerGroups,
	putCustomerGroup,
	getAdCustNotDowload,
	getAdCustNotConfirmed,
	getAdProvNotDowload,
	getProvNotDowload,
	getCustNotDowload,
	getCustNotConfirmed,
	getFilePath,
	getDownloadList,
	getConfirmList,
	searchFile,
	getMakeDeliverableList,
	makeDeliverableExchange,
	makeDeliverableCustomer,
	putSftpCustomer,
	deleteSftpCustomer,
	getMe
} from '@/api/api';
import AWS from "aws-sdk";
import { Auth } from 'aws-amplify';
import awsmobile from '@/api/aws-exports';
var log = require('log-util');

import { DISMISS_AFTER, mapCognitoLoggedUser, buildPaths } from "@/constants.js"

Vue.use(Vuex);

export const state = {
	user: null,
	userRole: '',
	paths: [],
	sharePaths: [],
	paths_operator: [],
	pathsToShare: [],
	operatorFolder: null,
	folderToUpload: null,
	folderToUploadSharedFile: null,
	organizations: [],
	companies: [],
	administrators: [],
	customers: [],
	providers: [],
	operators: [],
	usersOfOrganization: [],
	folderList: [],
	uploadContainer: [],
	linkedUsers: [],
	msgs: [],
	percentage: [],
	selectedOrganization: '',
	selectedCompany: '',
	numbersItem: {},
	itemsNeedAction: [],
	adminDashboard: [],
	providerDashboard: [],
	customerDashboard: [],
	linkedPath: [],
	linkedFile: [],
	notLinkedPath: [],
	notLinkedFile: [],
	errorForBadge: false,
	urlsToDownload: [],
	downloaderList: [],
	confirmerList: [],
	makeDeliverableList: []
};
export const mutations = {
	setUser(internal_state, data) {
		internal_state.user = data;
	},
	setUserSftp(internal_state, data) {
		internal_state.user.sftp = data;
	},
	setUserRole(internal_state, data) {
		switch (true) {
			case data.includes('Admin'):
				internal_state.userRole = 'Admin';
				break;
			case data.includes('Operator'):
				internal_state.userRole = 'Admin';
				break;
			case data.includes('Provider'):
				internal_state.userRole = 'Provider';
				break;
			case data.includes('Customer'):
				internal_state.userRole = 'Customer';
				break;
			default:
				internal_state.userRole = 'Customer';
				break;
		}
	},
	pushPath(internal_state, data) {
		switch (data.key) {
			case 'linkedFile':
				internal_state.linkedPath.push(data.paths);
				break;
			case 'notLinkedFile':
				internal_state.notLinkedPath.push(data.paths);
				break;
			default:
				internal_state.paths.push(data.paths);
				internal_state.paths.sort(function (a, b) {
					var nameA = a.name.toUpperCase(); // ignora maiuscole e minuscole
					var nameB = b.name.toUpperCase(); // ignora maiuscole e minuscole
					if (nameA < nameB) {
						return -1;
					}
					if (nameA > nameB) {
						return 1;
					}
					return 0;
				});
				break;
		}
	},
	setPath(internal_state, data) {
		if (!internal_state.paths) { internal_state.paths = []; }
		data.forEach(el => {
			internal_state.paths.push(el);
		})
		internal_state.paths.sort(function (a, b) {
			var nameA = a.name.toUpperCase(); // ignora maiuscole e minuscole
			var nameB = b.name.toUpperCase(); // ignora maiuscole e minuscole
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}
			return 0;
		});
	},
	setPathToShare(internal_state, data) {
		if (!internal_state.sharePaths) { internal_state.sharePaths = []; }
		data.forEach(el => {
			internal_state.sharePaths.push(el);
		})
		internal_state.sharePaths.sort(function (a, b) {
			var nameA = a.name.toUpperCase(); // ignora maiuscole e minuscole
			var nameB = b.name.toUpperCase(); // ignora maiuscole e minuscole
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}
			return 0;
		});
	},
	deletePath(internal_state, data) {
		internal_state.paths = [...internal_state.paths.filter(f => !f.name.includes(data))];
	},
	resetPath(internal_state, data) {
		internal_state.paths = data;
		internal_state.folderToUpload = null;
	},
	resetPathToShare(internal_state, data) {
		internal_state.sharePaths = data;
		internal_state.pathsToShare = data;
		internal_state.folderToUploadSharedFile = null;
	},
	setPathOperator(internal_state, data) {
		internal_state.paths_operator = data
		internal_state.paths_operator.sort(function (a, b) {
			var nameA = a.name.toUpperCase(); // ignora maiuscole e minuscole
			var nameB = b.name.toUpperCase(); // ignora maiuscole e minuscole
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}
			return 0;
		});
	},
	setPathToShareMutation(internal_state, data) {
		internal_state.pathsToShare = data
		internal_state.pathsToShare.sort(function (a, b) {
			var nameA = a.name.toUpperCase(); // ignora maiuscole e minuscole
			var nameB = b.name.toUpperCase(); // ignora maiuscole e minuscole
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}
			return 0;
		});
	},
	setFolderToUpload(internal_state, data) { internal_state.folderToUpload = data; },
	setFolderToUploadSharedFile(internal_state, data) { internal_state.folderToUploadSharedFile = data; },
	setOrganizations(internal_state, data) { internal_state.organizations = data; },
	pushOrganization(internal_state, data) { internal_state.organizations.push(data); },
	setCompanies(internal_state, data) { internal_state.companies = data; },
	pushCompanies(internal_state, data) { internal_state.companies.push(data); },
	setUsers(internal_state, data) {
		switch (true) {
			case data.role === 'Admin':
				internal_state.administrators = data.users;
				break;
			case data.role === 'Operator':
				internal_state.operators = data.users;
				break;
			case data.role === 'Provider':
				internal_state.providers = data.users;
				break;
			case data.role === 'Customer':
				internal_state.customers = data.users;
				break;
			default:
				internal_state.customers = data.users;
				break;
		}
	},
	pushUsers(internal_state, data) {
		switch (true) {
			case data.role === 'Admin':
				internal_state.administrators.push(data);
				break;
			case data.role === 'Operator':
				internal_state.operators.push(data);
				break;
			case data.role === 'Provider':
				internal_state.providers.push(data);
				break;
			case data.role === 'Customer':
				internal_state.customers.push(data);
				break;
			default:
				internal_state.customers.push(data);
				break;
		}
	},
	removeUsersMutation(internal_state, data) {
		switch (true) {
			case data.role === 'Admin':
				internal_state.administrators = [...internal_state.administrators.filter(f => f.email !== data.email)];
				break;
			case data.role === 'Operator':
				internal_state.operators = [...internal_state.operators.filter(f => f.email !== data.email)];
				break;
			case data.role === 'Provider':
				internal_state.providers = [...internal_state.providers.filter(f => f.email !== data.email)];
				break;
			case data.role === 'Customer':
				internal_state.customers = [...internal_state.customers.filter(f => f.email !== data.email)];
				break;
			default:
				internal_state.customers = [...internal_state.customers.filter(f => f.email !== data.email)];
				break;
		}
	},
	popGroup(internal_state, data) {
		switch (true) {
			case data.role === 'Provider':
				internal_state.organizations = [...internal_state.organizations.filter(f => f.name !== data.name)];
				break;
			case data.role === 'Customer':
				internal_state.companies = [...internal_state.companies.filter(f => f.name !== data.name)];
				break;
			default:
				internal_state.companies = [...internal_state.companies.filter(f => f.name !== data.name)];
				break;
		}
	},
	setUsersOfOrganization(internal_state, data) { internal_state.usersOfOrganization = data; },
	pushUserOfOrganization(internal_state, data) { internal_state.usersOfOrganization.push(data); },
	pushFolderList(internal_state, data) { internal_state.folderList = data; },
	pushOperatorFolder(internal_state, data) { internal_state.operatorFolder = data; },
	pushUpload(internal_state, data) { internal_state.uploadContainer.push(data); },
	resetUpload(internal_state) { internal_state.percentage = []; },
	pushLinkedUser(internal_state, data) { internal_state.linkedUsers.push(data); },
	setLinkedUsersList(internal_state, data) { internal_state.linkedUsers = data; },
	removeLinkedCustomer(internal_state, data) {
		internal_state.linkedUsers = [...internal_state.linkedUsers.filter(f => f.username !== data)];
		internal_state.customers.push(data);
	},
	pushMsgs(internal_state, data) { internal_state.msgs.unshift(data); },
	resetMsgs(internal_state) { internal_state.msgs = []; },
	setSelectedOrganization(internal_state, data) { internal_state.selectedOrganization = data; },
	setSelectedCompany(internal_state, data) { internal_state.selectedCompany = data; },
	setPercentage(internal_state, data) {
		let find = false;
		internal_state.percentage.forEach(el => {
			if (el.key === data.key) {
				el.percent = data.percent;
				el.status = data.status;
				find = true;
			}
		})
		if (!find) {
			internal_state.percentage.unshift({ key: data.key, percent: data.percent, status: data.status });
		}
	},
	resetPercentage(internal_state) {
		internal_state.percentage = [];
		internal_state.uploadContainer = [];
		internal_state.msgs = [];
		internal_state.errorForBadge = false;
	},
	setNumbersItem(internal_state, data) { internal_state.numbersItem = data; },
	setItemsNeedAction(internal_state, data) {
		data.forEach(el => { el.id = el.bucket + el.path });
		internal_state.itemsNeedAction = data;
	},
	resetItemsNeedAction(internal_state) {
		internal_state.itemsNeedAction = [];
	},
	setDashboardAdmin(internal_state, data) {
		internal_state.adminDashboard = data;
	},
	setDashboardProvider(internal_state, data) {
		internal_state.providerDashboard = data;
	},
	setDashboardCustomer(internal_state, data) {
		internal_state.customerDashboard = data;
	},
	setLinkedPath(internal_state, data) {
		internal_state.linkedPath = data;
	},
	getLinkedFileMutation(internal_state, data) {
		internal_state.linkedFile = data;
	},
	setNotLinkedPath(internal_state, data) {
		internal_state.notLinkedPath = data;
	},
	getNotLinkedFileMutation(internal_state, data) {
		internal_state.notLinkedFile = data;
	},
	setErrorForBadge(internal_state, data) {
		internal_state.errorForBadge = data;
	},
	confirmFileMutation(internal_state) {
		internal_state.customerDashboard.file_not_conf--;
	},
	downloadFileMutation(internal_state) {
		internal_state.customerDashboard.file_not_down--;
		internal_state.providerDashboard.file_to_down--;
		internal_state.adminDashboard.prov_not_down--;
	},
	setListDownloader(internal_state, data) {
		internal_state.downloaderList = [...data];
	},
	setListConfirmer(internal_state, data) {
		internal_state.confirmerList = [...data];
	},
	makeDeliverableMutation(internal_state, data) {
		internal_state.makeDeliverableList = [...data.map(e => {
			if(e.deliveredBy.includes("Prysmian_")) {
				e.deliveredBy = e.deliveredBy.replace('Prysmian_', '')
				return e
			}
		})];
	},
	makeFolderDeliverableMutation(internal_state, data) {
		internal_state.makeDeliverableList.push(data);
	},
	putSftpCustomerMutation(internal_state) {
		internal_state.user.sftp = true;
	},
	deleteSftpCustomerMutation(internal_state) {
		internal_state.user.sftp = false;
	}
};
export const actions = {
	setFolderToUploadAction({ commit, dispatch }, data) {
		commit("setFolderToUpload", data);
		state.paths.forEach((el) => {
			if (el.name === data.name) {
				el.selected = el.selected ? (false) : true;
				if (!el.selected) {
					commit('setFolderToUpload', '');
				}
			} else {
				el.selected = false;
			}
		})
		dispatch('buildTree', { paths: this.state.paths, key: 'tree' });
	},
	setFolderToUploadSharedFileAction({ commit, dispatch }, data) {
		commit("setFolderToUploadSharedFile", data);
		state.sharePaths.forEach((el) => {
			if (el.name === data.name) {
				el.selected = el.selected ? (false) : true;
				if (!el.selected) {
					commit('setFolderToUploadSharedFile', '');
				}
			} else {
				el.selected = false;
			}
		})
		dispatch('buildTree', { paths: this.state.sharePaths, key: 'treeToShareFile' });
	},
	dispatchError({ dispatch }, err) {
		dispatch(ADD_TOAST_MESSAGE, err);
	},
	addMsgs({ commit }, data) {
		commit('pushMsgs', data);
	},
	setNameOfOrganization({ commit }, data) {
		commit('setSelectedOrganization', data);
	},
	setNameOfCompany({ commit }, data) {
		commit('setSelectedCompany', data);
	},
	buildTree({ commit }, data) {
		let res;
		switch (data.key) {
			case 'tree':
				res = buildPaths(data.paths);
				commit('setPathOperator', res);
				break;
			case 'treeToShareFile':
				res = buildPaths(data.paths);
				commit('setPathToShareMutation', res);
				break;
			case 'linkedFile':
				res = buildPaths(data.paths);
				commit('getLinkedFileMutation', res);
				break;
			case 'notLinkedFile':
				res = buildPaths(data.paths);
				commit('getNotLinkedFileMutation', res);
				break;
			case 'updateTree':
				commit('setPathOperator', this.state.paths);
				break;
			case 'updateLinkedFile':
				commit('getLinkedFileMutation', this.state.linkedPath);
				break;
			case 'updateNotLinkedFile':
				commit('getNotLinkedFileMutation', this.state.notLinkedPath);
				break;
			default:
				res = buildPaths(data.paths);
				commit('setPathOperator', res);
				break;
		}
	},
	updateTree({ commit, dispatch }, data) {
		let el = {
			key: data.key ? data.key : 'tree',
			paths: {
				locked: data.locked ? data.locked : false,
				path: data.paths,
				creation_time: new Date(),
				creator: this.state.user.email,
				name: data.name,
				storage_class: data.StorageClass ? data.StorageClass : "INTELLIGENT_TIERING"
			}
		}
		commit('pushPath', el);
		switch (data.key) {
			case 'tree':
				dispatch('buildTree', { paths: this.state.paths, key: data.key ? data.key : 'updateTree' });
				break;
			case 'linkedFile':
				dispatch('buildTree', { paths: this.state.linkedPath, key: data.key ? data.key : 'updateLinkedFile' });
				break;
			case 'notLinkedFile':
				dispatch('buildTree', { paths: this.state.notLinkedPath, key: data.key ? data.key : 'updateNotLinkedFile' });
				break;
			default:
				dispatch('buildTree', { paths: this.state.paths, key: data.key ? data.key : 'updateTree' });
				break;
		}
	},
	async setTree({ commit, dispatch }, data) {
		try {
			let tree = await getTree(data.bucket, data.father, data.parent);
			commit('setPath', tree.data.getTree);
			dispatch('buildTree', { paths: this.state.paths, key: 'tree' });
		} catch (err) {
			log.error(err);
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});
		}
	},
	async setTreeToShare({ commit, dispatch }, data) {
		try {
			let tree = await getTree(data.bucket, data.father, data.parent);
			tree.data.getTree.push(
				{
					confirmation_time: null,
					confirmed_by: null,
					creation_time: "",
					creator: "Prysmian",
					download_time: "",
					download_user: "",
					downloaded: null,
					lock_time: "",
					locked: false,
					locked_by: "",
					name: data.father,
					operator_download_time: null,
					path: data.father.split("@")[1],
					provider_download_time: null,
					selected: false,
					shared_by: null,
					sharing_time: null,
					size: 0,
					storage_class: "Normal"
				}
			)
			commit('setPathToShare', tree.data.getTree);
			dispatch('buildTree', { paths: this.state.sharePaths, key: 'treeToShareFile' });
		} catch (err) {
			log.error("first", err);
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});
		}
	},
	async getLinkedFileAction({ commit, dispatch }, data) {
		try {
			let resp = await getLinkedFile(data.name, data.parent);
			if (data.path) {
				commit('setLinkedPath', resp.data.getLinkedFile);
				dispatch('buildTree', { paths: resp.data.getLinkedFile, key: 'linkedFile' });
			} else {
				resp.data.getLinkedFile.forEach(el => {
					dispatch('updateTree', { paths: el.name, name: el.name, key: 'linkedFile' });
				})
			}
		} catch (err) {
			log.error(err);
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});
		}
	},
	async getNotLinkedFileAction({ commit, dispatch }, data) {
		try {
			let resp = await getNotLinkedFile(data.name, data.parent);
			if (data.path) {
				commit('setNotLinkedPath', resp.data.getNotLinkedFile);
				dispatch('buildTree', { paths: resp.data.getNotLinkedFile, key: 'notLinkedFile' });
			} else {
				resp.data.getNotLinkedFile.forEach(el => {
					dispatch('updateTree', { paths: el.name, name: el.name, key: 'notLinkedFile' });
				})
			}
		} catch (err) {
			log.error(err);
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});
		}
	},
	async deleteFolderFromTree({ commit, dispatch }, data) {
		var deleteFile = new AWS.S3;
		var _this = this;
		if (data.path.length > 0) {
			data.path.forEach((p, index) => {
				var params = {
					Bucket: data.bucket,
					Key: p.name
				};
				try {
					deleteFile.deleteObject(params, function (err) {
						if (err) {
							dispatch(ADD_TOAST_MESSAGE, {
								text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
								type: 'danger'
							});
						}
						else {
							if (index >= data.path.length - 1 && !data.no_message) {
								dispatch(ADD_TOAST_MESSAGE, {
									text: ({ message: 'Folder deleted' }).message.substr(0, 50) + '...',
									type: 'success'
								});
							}
							data.path.forEach((el) => {
								commit('deletePath', el.name);
							})
							dispatch('buildTree', { paths: _this.state.paths, key: 'tree' });
						}
					});
				} catch (err) {
					dispatch(ADD_TOAST_MESSAGE, {
						text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
						type: 'danger'
					});

				}
			})
		} else {
			dispatch(ADD_TOAST_MESSAGE, {
				text: ({ message: 'Folder is empty' }).message.substr(0, 50) + '...',
				type: 'warning'
			});
		}
	},
	async setStateItem({ dispatch }, data) {
		try {
			if (data.action === 'open') {
				dispatch(ADD_TOAST_MESSAGE, {
					text: ({ message: 'Unlocking folder' }).message.substr(0, 50) + '...',
					type: 'warning'
				});
				await unlockFile(data.name);
				dispatch(ADD_TOAST_MESSAGE, {
					text: ({ message: 'Folder unlocked' }).message.substr(0, 50) + '...',
					type: 'success'
				});
			} else if (data.action === 'lock') {
				dispatch(ADD_TOAST_MESSAGE, {
					text: ({ message: 'Locking folder' }).message.substr(0, 50) + '...',
					type: 'warning'
				});
				await lockFile(data.name);
				dispatch(ADD_TOAST_MESSAGE, {
					text: ({ message: 'Folder Locked' }).message.substr(0, 50) + '...',
					type: 'success'
				});
			}
			state.paths.forEach((el) => {
				if (el.name.includes(data.name)) { el.locked = data.action === 'open' ? false : true; }
			})
			dispatch('buildTree', { paths: this.state.paths, key: 'tree' });
		} catch (err) {
			log.error(err);
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});
		}
	},
	async confirmFileAction({ commit, dispatch }, data) {
		try {
			await confirmFile(data.path);
			dispatch(ADD_TOAST_MESSAGE, {
				text: ({ message: 'File confirmed' }).message.substr(0, 50) + '...',
				type: 'success'
			});
			commit('confirmFileMutation');
			state.paths.forEach((el) => {
				if (el.name.includes(data.name)) { el.confirmation_time = new Date(); }
			})
			dispatch('buildTree', { paths: this.state.paths, key: 'tree' });
		} catch (err) {
			log.error(err);
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});
		}
	},

	async setCredentials({ dispatch }) {
		try {
			const session = await Auth.currentSession();
			AWS.config.region = awsmobile.aws_project_region;
			AWS.config.credentials = new AWS.CognitoIdentityCredentials({
				IdentityPoolId: awsmobile.cognito_identity_pool_id,
				Logins: {
					[`cognito-idp.${awsmobile.aws_project_region}.amazonaws.com/${awsmobile.Auth.userPoolId}`]: session
						.getIdToken()
						.getJwtToken(),
				},
			});
		} catch (err) {
			log.error(err);
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});
		}
	},
	async refreshToken({ dispatch }) {
		try {
			setInterval(async () => {
				const session = await Auth.currentSession();
				const refresh_token = session.getRefreshToken();   // you'll get session from calling cognitoUser.getSession
				const cognitoUser = await Auth.currentAuthenticatedUser();
				cognitoUser.refreshSession(refresh_token, (err, session) => {
					if (err) {
						log.error(err);
						dispatch(ADD_TOAST_MESSAGE, {
							text: (err || { message: 'Generic Error' }).message.substr(0, 50) + '...',
							type: 'danger'
						});
					}
					else {
						AWS.config.credentials.params.Logins[`cognito-idp.${awsmobile.aws_project_region}.amazonaws.com/${awsmobile.Auth.userPoolId}`] = session.getIdToken().getJwtToken();
						AWS.config.credentials.refresh((err) => {
							if (err) {
								log.error(err);
								dispatch(ADD_TOAST_MESSAGE, {
									text: (err || { message: 'Generic Error' }).message.substr(0, 50) + '...',
									type: 'danger'
								});
							}
							else {
								console.log("TOKEN SUCCESSFULLY UPDATED");
							}
						});
					}
				});
			}, 3000000);
		} catch (err) {
			log.error(err);
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});
		}
	},
	async setUser({ commit }) {
		try {
			const currentSession = await Auth.currentSession();
			currentSession.idToken.payload.jwtToken = currentSession.idToken.jwtToken;
			const userData = mapCognitoLoggedUser(currentSession.idToken.payload);
			if (userData) {
				if (userData.groupName.includes('Administrator') || userData.groupName.includes('Operator')) {
					commit('setUser', userData);
					commit('setUserRole', userData.groupName);
				} else {
					commit('setUser', userData);
					commit('setUserRole', userData.role);
				}
			}
		} catch (err) {
			log.error("setUser error",err);
			await Auth.federatedSignIn({ provider: "COGNITO" });
		}
	},
	async getMeAction ({ commit, dispatch }) {
		try {
			const resp = await getMe();
			commit('setUserSftp', resp.data.getMe.sftp ? resp.data.getMe.sftp : false);
		} catch (err) {
			log.error(err);
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});
		}
	},
	async getOrganizationsTable({ commit, dispatch }) {
		try {
			const resp = await getOrganizations();
			commit('setOrganizations', resp.data.getOrganizations);
		} catch (err) {
			log.error(err);
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});
		}
	},
	async putOrganizationsTable({ commit, dispatch }, data) {
		try {
			const resp = await putOrganization(data.name, data.description);
			commit('pushOrganization', resp.data.putOrganization);
			dispatch(ADD_TOAST_MESSAGE, {
				text: 'Provider added',
				type: 'success'
			});
		} catch (err) {
			log.error(err);
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});
		}
	},
	async getGroupTable({ commit, dispatch }) {
		try {
			const resp = await getCustomerGroups();
			commit('setCompanies', resp.data.getCustomerGroups);
		} catch (err) {
			log.error(err);
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});
		}
	},
	async putGroupTable({ commit, dispatch }, data) {
		try {
			const resp = await putCustomerGroup(data.name, data.description);
			commit('pushCompanies', resp.data.putCustomerGroup);
			dispatch(ADD_TOAST_MESSAGE, {
				text: `${data.type} added`,
				type: 'success'
			});
		} catch (err) {
			log.error(err);
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});
		}
	},
	async setUsers({ commit, dispatch }, data) {
		try {
			let resp = await getUsers(data.role, data.organization);
			let _data = {
				users: resp.data.getUsers,
				role: data.role
			}
			commit('setUsers', _data);
		} catch (err) {
			log.error(err);
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});
		}
	},
	async putUsers({ commit, dispatch }, data) {
		try {
			let resp = await putUser(data.organization, data.username, data.name, data.phone, data.role, data.sftp, data.surname);
			let _data = {
				id: resp.data.putUser.id,
				active: resp.data.putUser.active,
				company: resp.data.putUser.company,
				email: resp.data.putUser.email,
				name: resp.data.putUser.name,
				surname: resp.data.putUser.surname,
				phone: resp.data.putUser.phone,
				role: resp.data.putUser.role,
				sftp: data.sftp
			}
			commit('pushUsers', _data);
			dispatch(ADD_TOAST_MESSAGE, {
				text: 'User added',
				type: 'success'
			});
		} catch (err) {
			log.error(err);
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});
		}
	},
	async removeUsers({ dispatch, commit }, data) {
		try {
			let resp = await deleteUser(data.key);
			commit('removeUsersMutation', { role: data.role, email: resp.data.deleteUser.username });
			dispatch(ADD_TOAST_MESSAGE, {
				text: 'User removed',
				type: 'success'
			});
		} catch (err) {
			log.error(err);
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});
		}
	},
	async removeGroup({ dispatch, commit }, data) {
		try {
			let resp = await deleteGroup(data.name);
			if (resp.data.deleteGroup) {
				commit('popGroup', { role: data.key, name: data.name });
				dispatch(ADD_TOAST_MESSAGE, {
					text: 'Group removed',
					type: 'success'
				});
			} else {
				dispatch(ADD_TOAST_MESSAGE, {
					text: 'This group still contains users. Delete them to continue.',
					type: 'warning'
				});
			}
		} catch (err) {
			log.error(err);
			if(err.errors[0].message.includes('BucketNotEmpty')) {
				dispatch(ADD_TOAST_MESSAGE, {
					text: 'Bucket not empty. Please try again in 30 days',
					type: 'danger'
				});
			} else {
				dispatch(ADD_TOAST_MESSAGE, {
					text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
					type: 'danger'
				});
			}
		}
	},
	async disableUsers({ dispatch }, data) {
		try {
			await disableUser(data.email);
			dispatch(ADD_TOAST_MESSAGE, {
				text: 'User disabled',
				type: 'success'
			});
		} catch (err) {
			log.error(err);
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});
		}
	},
	async enableUsers({ dispatch }, data) {
		try {
			await enableUser(data.email);
			dispatch(ADD_TOAST_MESSAGE, {
				text: 'User enabled',
				type: 'success'
			});
		} catch (err) {
			log.error(err);
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});
		}
	},
	async resetPasswordAction({ dispatch }, data) {
		try {
			await resetPassword(data.key);
			dispatch(ADD_TOAST_MESSAGE, {
				text: 'User password resetted',
				type: 'success'
			});
		} catch (err) {
			log.error(err);
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});
		}
	},
	async setFolderListOperator({ commit, dispatch }, data) {
		try {
			const resp = await getFolderListOperator(data);
			commit('pushFolderList', resp.data.getFolderList);
		} catch (err) {
			log.error(err);
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});
		}
	},
	async setOperatorFolder({ commit }, data) {
		commit('pushOperatorFolder', data);
	},
	async linkFolderCustomer({ commit, dispatch }, data) {
		try {
			let resp = await linkFolder(data.username, data.path);
			commit('pushLinkedUser', resp.data.linkFolder);
			dispatch(ADD_TOAST_MESSAGE, {
				text: 'Customer linked with folder',
				type: 'success'
			});
		} catch (err) {
			log.error(err);
			dispatch(ADD_TOAST_MESSAGE, {
				text: ({ message: 'Your request has been received and will be processed in background.' }).message,
				type: 'success'
			});
			// dispatch(ADD_TOAST_MESSAGE, {
			// 	text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
			// 	type: 'danger'
			// });
		}
	},
	async setLinkdeUser({ commit, dispatch }, data) {
		try {
			let resp = await getLinkedUser(data);
			commit('setLinkedUsersList', resp.data.getLinkedUser);
		} catch (err) {
			log.error(err);
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});
		}
	},
	async removeLinkFolderCustomer({ dispatch, commit }, data) {
		try {
			await removeLinkFolder(data.username, data.path);
			commit('removeLinkedCustomer', data.username);
			dispatch(ADD_TOAST_MESSAGE, {
				text: ({ message: 'Customer disconnected from the folder' }).message.substr(0, 50) + '...',
				type: 'success'
			});
		} catch (err) {
			log.error(err);
			dispatch(ADD_TOAST_MESSAGE, {
				text: ({ message: 'Your request has been received and will be processed in background.' }).message,
				type: 'success'
			});
			// dispatch(ADD_TOAST_MESSAGE, {
			// 	text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
			// 	type: 'danger'
			// });
		}
	},
	async getFilePathAction({ dispatch }, data) {
		try {
			let resp = await getFilePath(data.father, data.bucket);
			await dispatch('deleteFolderFromTree', { no_message: true, bucket: data.bucket, path: resp.data.getFilePath })
			await dispatch('deleteFolderFromTree', { bucket: data.bucket, path: [{ name: data.father, path: data.father }] })
		} catch (err) {
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});
		}
	},
	async getDownloadLink({ commit, dispatch }, data) {
		try {
			dispatch(ADD_TOAST_MESSAGE, {
				text: ({ message: 'Start download' }).message.substr(0, 50) + '...',
				type: 'warning'
			});
			let resp = await getFile(data.father, data.bucket);
			resp.data.getFile.forEach(el => {
				window.open(el, '_blank');
				if (data.from_dash) commit('downloadFileMutation');
			})
			dispatch(ADD_TOAST_MESSAGE, {
				text: ({ message: `file${resp.data.getFile.length > 1 ? 's' : ''} downloaded` }).message.substr(0, 50) + '...',
				type: 'success'
			});
		} catch (err) {
			dispatch(ADD_TOAST_MESSAGE, {
				text: ({ message: 'Too many file to download, please select a subfolder' }).message,
				type: 'danger'
			});
		}
	},
	async setUpload({ commit, dispatch }, data) {
		commit('pushUpload', data);
		const params = data;
		dispatch("addMsgs", {
			name: params.Key,
			action: "start",
			date: new Date().toUTCString()
		});
		var upload = new AWS.S3.ManagedUpload({
			params,
			leavePartsOnError: true
		});
		upload.on("httpUploadProgress", function (progress) {
			commit('setPercentage', { key: params.Key, percent: (progress.loaded / progress.total) * 100, status: true });
		});

		try {
			upload.send(function (err) {
				if (err) {
					log.error(err);
				}
				dispatch("addMsgs", {
					name: params.Key,
					action: "end",
					date: new Date().toUTCString()
				});
			});
		} catch (err) {
			commit('setErrorForBadge', true);
			commit('setPercentage', { key: params.Key, percent: 0, status: false });
			dispatch("addMsgs", {
				name: "Networking Error",
				action: "error",
				text: err,
				date: new Date().toUTCString()
			});
			dispatch("dispatchError", {
				text: err.substr(0, 35) + " ...",
				type: "danger"
			});
			log.error(err);
		}
	},
	resetUpload({ commit, dispatch }) {
		try {
			commit('resetPercentage');
		} catch (err) {
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});
			log.error(err);
		}
	},
	setNumbersItemsToNeedAction({ commit, dispatch }) {
		try {
			let data = {
				customer_not_download: 12,
				customer_not_confirm: 5,
				provider_not_download: 7,
				provider_not_confirm: 25
			}
			commit('setNumbersItem', data);
		} catch (err) {
			log.error(err);
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});
		}
	},
	async setItemTo({ commit, dispatch }, key) {
		let resp = {};

		try {
			switch (key) {
				case 'download_customer':
					resp = await getAdCustNotDowload();
					console.log("resp.data.getAdCustNotDowload", resp.data.getAdCustNotDowload);
					commit('setItemsNeedAction', resp.data.getAdCustNotDowload ? resp.data.getAdCustNotDowload : []);
					break;

				case 'confirm_customer':
					resp = await getAdCustNotConfirmed();
					commit('setItemsNeedAction', resp.data.getAdCustNotConfirmed ? resp.data.getAdCustNotConfirmed : []);
					break;

				case 'download_provider':
					resp = await getAdProvNotDowload();
					commit('setItemsNeedAction', resp.data.getAdProvNotDowload ? resp.data.getAdProvNotDowload : []);
					break;

				case 'provider_download':
					resp = await getProvNotDowload();
					commit('setItemsNeedAction', resp.data.getProvNotDowload ? resp.data.getProvNotDowload : []);
					break;

				case 'download':
					resp = await getCustNotDowload();
					console.log("resp.data.getCustNotDowload", resp.data.getCustNotDowload);
					commit('setItemsNeedAction', resp.data.getCustNotDowload ? resp.data.getCustNotDowload : []);
					break;

				case 'confirm':
					resp = await getCustNotConfirmed();
					commit('setItemsNeedAction', resp.data.getCustNotConfirmed ? resp.data.getCustNotConfirmed : []);
					break;

				default:
					break;
			}
		} catch (err) {
			log.error(err);
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});
		}
	},
	async setDashboard({ commit, dispatch }, data) {
		let resp = {};
		try {
			switch (data) {
				case 'Admin':
					resp = await getDashboardAdmin();
					commit('setDashboardAdmin', resp.data.getDashboardAdmin ? resp.data.getDashboardAdmin[0] : {cust_not_down: 0, cust_not_conf: 0, prov_not_down: 0});
					break;

				case 'Provider':
					resp = await getDashboardProvider();
					commit('setDashboardProvider', resp.data.getDashboardProvider ? resp.data.getDashboardProvider[0] : {file_to_down: 0} );
					break;

				case 'Customer':
					resp = await getDashboardCustomer();
					console.log("setDashboardCustomer resp",resp)
					commit('setDashboardCustomer', resp.data.getDashboardCustomer ? resp.data.getDashboardCustomer[0] : {file_not_down: 0, file_not_conf: 0});
					break;
			}
		} catch (err) {
			log.error(err);
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});
		}
	},
	async getDownloadList({ commit, dispatch }, data) {
		try {
			let resp = await getDownloadList(data);
			commit('setListDownloader', resp.data.getDownloadList)
		} catch (err) {
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});

		}
	},
	async getConfirmedList({ commit, dispatch }, data) {
		try {
			let resp = await getConfirmList(data);
			commit('setListConfirmer', resp.data.getConfirmList)
		} catch (err) {
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});

		}
	},
	async getSearchFile({ commit, dispatch }, data) {
		try {
			let resp = await searchFile(data.bucket, data.search);
			commit('resetPath', []);
			commit('setPath', resp.data.searchFile);
			await dispatch('buildTree', { paths: this.state.paths, key: 'tree' });
		} catch (err) {
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});

		}
	},
	async listMakeDeliverable ({ dispatch, commit }, data) {
		try {
			let resp = await getMakeDeliverableList(data);
			resp.data.getMakeDeliverableList.sort((a,b) => {
				return new Date(b.createdAt) - new Date(a.createdAt);
			})
			commit('makeDeliverableMutation', resp.data.getMakeDeliverableList);
		} catch (err) {
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});
		}
	},
	async makeFolderDeliverable({ dispatch, commit }, data) {
		try {
			let resp = await makeDeliverableExchange(data.elementToDeliver, data.deliverFolder.name);
			commit('makeFolderDeliverableMutation', resp.data.makeDeliverableExchange);
			dispatch(ADD_TOAST_MESSAGE, {
				text: ({ message: 'The operation has been taken over' }).message.substr(0, 50) + '...',
				type: 'info'
			});
		} catch (err) {
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});

		}
	},
	async makeFolderDeliverableCustomer({ dispatch, commit }, data) {
		try {
			let resp = await makeDeliverableCustomer(data.elementToDeliver, data.deliverFolder, data.groupName);
			commit('makeFolderDeliverableMutation', resp.data.makeDeliverableCustomer);
			dispatch(ADD_TOAST_MESSAGE, {
				text: ({ message: 'The operation has been taken over' }).message.substr(0, 50) + '...',
				type: 'info'
			});
		} catch (err) {
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});

		}
	},
	async putSftpCustomerAction({ commit, dispatch }, data) {
		try {
			await putSftpCustomer(data.sub, data.email, data.role, data.firstName, data.lastName, data.phone, data.groupName);
			commit('putSftpCustomerMutation');
			dispatch(ADD_TOAST_MESSAGE, {
				text: 'Sftp user added',
				type: 'success'
			});
		} catch (err) {
			log.error(err);
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});
		}
	},
	async deleteSftpCustomerAction({ dispatch, commit }, data) {
		try {
			await deleteSftpCustomer(data.sub, data.email);
			commit('deleteSftpCustomerMutation');
			dispatch(ADD_TOAST_MESSAGE, {
				text: 'Sftp user removed',
				type: 'success'
			});
		} catch (err) {
			log.error(err);
			dispatch(ADD_TOAST_MESSAGE, {
				text: (err.errors[0] || { message: 'Generic Error' }).message.substr(0, 50) + '...',
				type: 'danger'
			});
		}
	},
}



const store = new Vuex.Store({
	state,
	mutations,
	actions,
	modules: {
		toast: createModule({
			dismissInterval: DISMISS_AFTER
		})
	}
});

export default store;